import { render, staticRenderFns } from "./UpdatesCardSample.vue?vue&type=template&id=1ab96dca&scoped=true&"
import script from "./UpdatesCardSample.vue?vue&type=script&lang=js&"
export * from "./UpdatesCardSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab96dca",
  null
  
)

export default component.exports